import { Component,
  Vue,
  Prop,
  Watch } from 'vue-property-decorator';
import { sanitizeString, ucwords } from '@/support/String';
import { closeDialog } from '@/support/Dialog';

@Component<MiDialog>({
  //
})
export default class MiDialog extends Vue {
  @Prop({ default: false })
  protected options!: MiDialogOptions;

  protected settings: MiDialogOptions | null = null;

  protected okButton = false;

  protected isConfirming = false;

  @Watch('options')
  public optionsChanged(options: MiDialogOptions | null) {
    if (options === null) {
      return;
    }

    this.settings = this.options;
  }

  public mounted() {
    if (this.options === null) {
      return;
    }

    this.settings = this.options;
  }

  public ucwords(value: string) {
    return ucwords(value);
  }

  public cancel() {
    if (this.hasCancelButton && this.settings && this.settings.buttons) {
      const button: MiDialogButtonOptions = this.settings.buttons.cancel as MiDialogButtonOptions;
      if (button.action) {
        button.action();
      }
    }

    this.close();
  }

  public async confirm() {
    this.isConfirming = true;

    if (this.hasConfirmButton && this.settings && this.settings.buttons) {
      const button: MiDialogButtonOptions = this.settings.buttons.confirm as MiDialogButtonOptions;

      if (button.action) {
        await button.action();
      }
    }

    this.isConfirming = false;

    if (this.settings?.buttons?.confirm?.autoClose === undefined || this.settings?.buttons?.confirm?.autoClose === true) {
      this.close();
    }
  }

  public close() {
    this.$emit('input', true);
    this.$emit('close', true);
  }

  get hasCancelButton(): boolean {
    if (! this.settings || ! this.settings.buttons || ! this.settings.buttons.cancel) {
      return false;
    }

    if (this.options.buttons && this.options.buttons.cancel && this.options.buttons.cancel.color === undefined) {
      this.options.buttons.cancel.color = 'warning';
    }

    return this.settings.buttons.cancel.text !== '';
  }

  get hasConfirmButton(): boolean {
    if (! this.settings || ! this.settings.buttons || ! this.settings.buttons.confirm) {
      return false;
    }

    if (this.options?.buttons?.confirm?.color && this.options.buttons.confirm.color === undefined) {
      this.options.buttons.confirm.color = 'success';
    }

    if (
      this.settings.buttons.confirm.text.toLowerCase() === 'ok'
    ) {
      this.okButton = true;
    } else {
      this.okButton = false;
    }

    return this.settings.buttons.confirm.text !== '';
  }

  protected sanitizeString(value: string): string {
    return sanitizeString(value, true);
  }

  protected closeDialog() {
    return closeDialog();
  }
}

export interface MiDialogOptions {
  title?: string;
  text: string;
  type: DialogType;
  buttons?: MiDialogButtons;
}

interface MiDialogButtons {
  confirm?: MiDialogButtonOptions;
  cancel?: MiDialogButtonOptions;
}

interface MiDialogButtonOptions {
  text: string;
  action?: Function;
  color?: string;
  autoClose?: boolean;
}

export type DialogType = 'error' | 'warning' | 'success';
